// The app shell's scroll container: merchant pages scroll inside it, not the window.
export const MAIN_SCROLL_CONTAINER_ID = "providers-main-content";
